import React from 'react';

import {useData, useModal} from 'containers/ManageOrganizationPage/hooks';
import OrganizationList from 'containers/ManageOrganizationPage/OrganizationList';
import AddOrganizationModal from 'containers/ManageOrganizationPage/AddOrganizationModal';
import {ROUTE} from 'containers/App/constants';

import {Loading} from 'components';

import SubHeader from './SubHeader';
import i18n from 'i18next';

export default function OrganizationSection() {
  const {data, loading} = useData();

  const {showModal, selectedOrganization, onShowModal, onClick} =
    useModal(data);

  return (
    <>
      <SubHeader
        title={i18n.t('dashboardPage.organisation.header')}
        linkTo={ROUTE.Organization}
        onClick={onClick()}
      />
      {loading ? (
        <Loading className="h-full-36" />
      ) : (
        <OrganizationList data={data} onClick={onClick} className="h-full-36" />
      )}
      <AddOrganizationModal
        show={showModal}
        onClose={onShowModal}
        selectedOrganization={selectedOrganization}
      />
    </>
  );
}
